var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"home games-page-list"},[_c('ViewBar'),_c('div',{staticClass:"main"},[_c('GameList'),_c('div',{staticClass:"game-table"})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }